import * as React from "react";
function SvgClose(props) {
    return (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none" }, props),
        React.createElement("path", { d: "M3.485 20.485l16.97-16.97M3.485 3.515l16.97 16.97", stroke: "currentColor" })));
}
export default SvgClose;
//# sourceMappingURL=Close.js.map